import { useEffect, useState } from 'react';
import { SettingsApi } from '../lib/api';
import type { Settings } from '@freebuff/shared';
import { Spinner } from '../components/Common';

export function Settings() {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [webhook, setWebhook] = useState('');
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    SettingsApi.get().then((r) => {
      setSettings(r.settings);
      setWebhook(r.settings.alertWebhookUrl ?? '');
    }).catch(() => null);
  }, []);

  if (!settings) return <Spinner />;

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null); setSaved(false);
    try {
      await SettingsApi.update({ alertWebhookUrl: webhook.trim() || null });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <section className="card">
        <div className="card-header">
          <div>
            <h2 className="text-lg font-semibold">Alertas — Discord/Slack</h2>
            <p className="text-xs text-slate-400">Configure a URL do webhook para onde os alertas serão enviados.</p>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={save} className="space-y-3">
            <div>
              <label className="label">Webhook URL</label>
              <input
                value={webhook}
                onChange={(e) => setWebhook(e.target.value)}
                placeholder="https://discord.com/api/webhooks/... ou https://hooks.slack.com/..."
                className="input font-mono text-sm"
              />
              <p className="text-xs text-slate-500 mt-2">Pode ser sobrescrito por regra específica.</p>
            </div>
            <div className="flex items-center gap-2">
              <button type="submit" className="btn btn-primary">Salvar</button>
              {saved && <span className="text-ok text-sm">✓ Salvo</span>}
              {error && <span className="text-danger text-sm">{error}</span>}
            </div>
          </form>
        </div>
      </section>

      <section className="card">
        <div className="card-header">
          <div>
            <h2 className="text-lg font-semibold">Retenção & Downsampling</h2>
            <p className="text-xs text-slate-400">Como o histórico é mantido (configuração via <code>.env</code>).</p>
          </div>
        </div>
        <div className="card-body">
          <table className="table">
            <tbody>
              <tr><td className="text-slate-400">Dados brutos</td><td className="font-mono">{settings.rawRetentionHours}h</td></tr>
              <tr><td className="text-slate-400">Agregado 1 min</td><td className="font-mono">{settings.oneMinRetentionDays}d</td></tr>
              <tr><td className="text-slate-400">Agregado 1 hora</td><td className="font-mono">{settings.oneHourRetentionDays}d</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="card">
        <div className="card-header"><h2 className="text-lg font-semibold">Sobre</h2></div>
        <div className="card-body text-sm text-slate-400">
          <p>FreeBuff — painel de monitoramento auto-hospedado. Código aberto, sem dependências externas além do seu VPS.</p>
          <p className="mt-2">Versão <span className="font-mono text-slate-300">0.1.0</span></p>
        </div>
      </section>
    </div>
  );
}
